import React from 'react'
import styled from 'styled-components'

import logoPoupaFooter from './logo-poupa-energia-footer.png'

/**
 * Rodapé da página de avaliação (versão super resumida do footer do portal).
 *
 * Ao contrário do footer.html completo (dezenas de links), aqui só temos:
 *  - o logo Poupa Energia à esquerda;
 *  - os links/ícones das redes sociais à direita;
 *  - uma barra inferior com "© ADENE {ano}".
 */

const SOCIALS = [
  {
    label: 'Facebook',
    href: 'https://www.facebook.com/agenciaparaaenergia',
    icon: (
      <path d='M13.5 21v-8h2.7l.4-3.1h-3.1V7.9c0-.9.25-1.5 1.55-1.5h1.65V3.6c-.3-.04-1.3-.13-2.45-.13-2.42 0-4.08 1.48-4.08 4.2v2.34H7.5V13h2.67v8h3.33z' />
    ),
  },
  {
    label: 'Instagram',
    href: 'https://www.instagram.com/adene.pt/',
    icon: (
      <path d='M12 7.2A4.8 4.8 0 1 0 12 16.8 4.8 4.8 0 0 0 12 7.2zm0 7.9a3.1 3.1 0 1 1 0-6.2 3.1 3.1 0 0 1 0 6.2zm4.9-8.1a1.1 1.1 0 1 1-2.2 0 1.1 1.1 0 0 1 2.2 0zM20 6.9c-.05-1.5-.4-2.85-1.5-3.94C17.4 1.86 16.06 1.5 14.56 1.45c-1.55-.09-6.2-.09-7.74 0C5.33 1.5 3.99 1.85 2.9 2.95 1.8 4.04 1.45 5.39 1.4 6.89c-.09 1.55-.09 6.2 0 7.75.05 1.5.4 2.84 1.5 3.94 1.09 1.1 2.43 1.45 3.93 1.5 1.55.09 6.19.09 7.74 0 1.5-.05 2.84-.4 3.94-1.5 1.1-1.1 1.45-2.44 1.5-3.94.09-1.55.09-6.19 0-7.74zm-2.03 9.4a3.14 3.14 0 0 1-1.77 1.77c-1.22.49-4.13.37-5.48.37-1.36 0-4.27.11-5.49-.37a3.14 3.14 0 0 1-1.77-1.77c-.48-1.22-.37-4.13-.37-5.49 0-1.35-.11-4.26.37-5.48A3.14 3.14 0 0 1 6.51 3.53c1.22-.48 4.13-.37 5.49-.37 1.35 0 4.26-.11 5.48.37a3.14 3.14 0 0 1 1.77 1.77c.49 1.22.37 4.13.37 5.48 0 1.36.12 4.27-.37 5.49z' />
    ),
  },
  {
    label: 'Linkedin',
    href: 'https://linkedin.com/company/adene',
    icon: (
      <path d='M6.94 5a1.94 1.94 0 1 1-3.88 0 1.94 1.94 0 0 1 3.88 0zM7 8.48H3V21h4V8.48zm6.32 0H9.34V21h3.94v-6.57c0-3.66 4.77-3.96 4.77 0V21H22v-7.93c0-6.17-7.06-5.94-8.72-2.91l.04-1.68z' />
    ),
  },
  {
    label: 'Youtube',
    href: 'https://www.youtube.com/c/ADENEAg%C3%AAnciaparaaEnergia',
    icon: (
      <path d='M23 12s0-3.2-.41-4.73a2.46 2.46 0 0 0-1.73-1.74C19.32 5.1 12 5.1 12 5.1s-7.32 0-8.86.42c-.85.23-1.51.9-1.73 1.75C1 8.8 1 12 1 12s0 3.2.41 4.73c.22.85.88 1.51 1.73 1.74 1.54.43 8.86.43 8.86.43s7.32 0 8.86-.42a2.46 2.46 0 0 0 1.73-1.75C23 15.2 23 12 23 12zM9.75 15.02V8.98L14.75 12l-5 3.02z' />
    ),
  },
]

export default function RatingFooter() {
  return (
    <Footer>
      <Bar>
        <a
          href='https://poupaenergia.pt/'
          target='_blank'
          rel='noopener noreferrer'>
          <Logo src={logoPoupaFooter} alt='Logo Poupa Energia' />
        </a>
        <Socials>
          {SOCIALS.map((s) => (
            <Social
              key={s.label}
              href={s.href}
              target='_blank'
              rel='noopener noreferrer'>
              <IconBox>
                <svg width='16' height='16' viewBox='0 0 24 24'>
                  {s.icon}
                </svg>
              </IconBox>
              <SocialLabel>{s.label}</SocialLabel>
            </Social>
          ))}
        </Socials>
      </Bar>
      <Copyright>© ADENE 2026</Copyright>
    </Footer>
  )
}

const Footer = styled.footer`
  width: 100%;
  background: #1e1e1e;
  color: #cfcfcf;
`

const Bar = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  flex-wrap: wrap;
`

const Logo = styled.img`
  height: 40px;
  width: auto;
  display: block;
`

const Socials = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
`

const Social = styled.a`
  display: flex;
  align-items: center;
  gap: 8px;
  color: #cfcfcf;
  text-decoration: none;

  &:hover {
    color: #fff;
  }
`

const IconBox = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border: 1px solid #6b6b6b;

  svg path {
    fill: currentColor;
  }
`

const SocialLabel = styled.span`
  font-family: Nunito;
  font-size: 14px;
  font-weight: 400;
`

const Copyright = styled.div`
  border-top: 1px solid #333;
  padding: 12px 24px;
  font-family: Nunito;
  font-size: 13px;
  color: #9a9a9a;
  text-align: center;
  width: 100%;
`



// WEBPACK FOOTER //
// ./src/components/RatingFooter/index.js